import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/help",
    name: "Help",
    // eslint-disable-next-line prettier/prettier
    component: () =>
      import(/* webpackChunkName: "help" */ "../views/Help.vue")
  },
  {
    path: "/book",
    name: "Book",
    // eslint-disable-next-line prettier/prettier
    component: () =>
      import(/* webpackChunkName: "book" */ "../views/Book.vue")
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/details",
    name: "Details",
    component: () =>
      import(/* webpackChunkName: "details" */ "../views/Details.vue")
  },
  {
    path: "/result",
    name: "Result",
    component: () =>
      import(/* webpackChunkName: "result" */ "../views/Result.vue")
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
